module.exports = __webpack_public_path__ + "static/media/video.3e3d54d0.mp4";